// Mobile Mail — Folder Drawer.
// Top: 6 folder items (Inbox / Sent / Drafts / All / Trash / Spam).
// Bottom: account switcher (reuses useMailAccounts data, no new API).
// Mobile Mail v1.2 (2026-09-14): added account section per user prompt §3.
// No settings / account management / AI per v1 scope.

import type { AccountV2View } from "../../modules/mail-v2/api/mappers";

export type FolderId = "inbox" | "sent" | "drafts" | "all" | "trash" | "spam";

export const FOLDERS: ReadonlyArray<{ id: FolderId; label: string }> = [
  { id: "inbox", label: "受信トレイ" },
  { id: "sent", label: "送信済み" },
  { id: "drafts", label: "下書き" },
  { id: "all", label: "すべてのメール" },
  { id: "trash", label: "ゴミ箱" },
  { id: "spam", label: "迷惑メール" },
];

interface Props {
  currentFolderId: FolderId;
  onSelect: (id: FolderId) => void;
  onClose: () => void;
  // v1.2: account switcher
  accounts: AccountV2View[];
  currentAccountId: string | null;
  onSelectAccount: (id: string) => void;
}

export const MobileFolderDrawer = ({
  currentFolderId,
  onSelect,
  onClose,
  accounts,
  currentAccountId,
  onSelectAccount,
}: Props) => {
  return (
    <>
      <div
        className="mobile-mail-drawer-backdrop"
        onClick={onClose}
        aria-hidden="true"
      />
      <aside className="mobile-mail-drawer" aria-label="フォルダ">
        <div className="mobile-mail-drawer-title">メールボックス</div>
        <div className="mobile-mail-drawer-folders">
          {FOLDERS.map((f) => (
            <button
              key={f.id}
              type="button"
              className={`mobile-mail-folder-item ${f.id === currentFolderId ? "active" : ""}`}
              onClick={() => onSelect(f.id)}
            >
              {f.label}
            </button>
          ))}
        </div>
        <div className="mobile-mail-drawer-account">
          {accounts.length === 0 ? (
            <div className="mobile-mail-drawer-account-empty">
              メールアカウントがありません
            </div>
          ) : (
            <>
              <div className="mobile-mail-drawer-account-label">
                アカウント切替
              </div>
              {accounts.map((a) => {
                const typeLabel =
                  a.accountType === "personal"
                    ? "個人"
                    : a.accountType === "shared"
                    ? "共有"
                    : "その他";
                return (
                  <button
                    key={a.id}
                    type="button"
                    className={`mobile-mail-drawer-account-item ${a.id === currentAccountId ? "active" : ""}`}
                    onClick={() => onSelectAccount(a.id)}
                  >
                    <span className="mobile-mail-drawer-account-email">
                      {a.email}
                    </span>
                    <span
                      className={`mobile-mail-drawer-account-type mobile-mail-drawer-account-type--${a.accountType}`}
                    >
                      {typeLabel}
                    </span>
                  </button>
                );
              })}
            </>
          )}
        </div>
      </aside>
    </>
  );
};
